import React, { useState } from 'react';
import Navbar from './Navbar'
import { auth } from '../firebase.js';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from "firebase/auth";

const ViewLogin = () => {
	const navigate = useNavigate();
	const [correo, establecerCorreo] = useState('');
	const [password, establecerPassword] = useState('');

	const handleChange = (e) => {
		if (e.target.name === 'email') {
			establecerCorreo(e.target.value);
		} else if (e.target.name === 'password') {
			establecerPassword(e.target.value);
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (correo === '' || password === '') {
			return;
		}
		try {
			await signInWithEmailAndPassword(auth, correo, password);
			console.log('entraste')
			navigate('/RecordHistory');
		} catch (error) {
			console.log(error)
		}
	}

	return (
		<div className='mt-4 mx-4'>
			<Navbar></Navbar>
			<div className="card bg-">
				<div className="card-body bg-white mx-2">
					<h1 className='card-title bg-white mx-2'>Hola,</h1>
					<p className='card-subtitle bg-white mx-2'>te damos la bienvenida a EY</p>
					<form className="bg-white mx-2" onSubmit={handleSubmit}>
						<div className='bg-white'>
							<input className='form-control bg-white'
								type="email"
								name="email"
								placeholder="Correo electrónico"
								value={correo}
								onChange={handleChange}
							/>
							<p className='email-title bg-white mx-2'>Nunca compartiremos tus datos personales</p>
							<input className='form-control bg-white'
								type="password"
								name="password"
								placeholder="Contraseña"
								value={password}
								onChange={handleChange}
							/>
						</div>
						<div className="form-check bg-white">
							<input type="checkbox" className="form-check-input" id="exampleCheck1"/>
								<label className="form-check-label bg-white" htmlFor="exampleCheck1">Recordarme</label>
						</div>
							<button className='btn-lg mt-6 mx-6' type='submit'>Inicia tu sesión</button>
					</form>
					<p className='text-password'>Solicita o recupera tu clave</p>
				</div>
			</div>
		</div>
	);
};

export default ViewLogin